import { TmrBaseResource } from 'stylewhere/api'
import { api, responseErrorCheck } from './api'

export interface DeviceActivityPayload {
  id?: string
  type: 'WORKSTATION'
  workstationId: string
  placeId: string
  description: string
  details: Record<string, unknown>
}

export interface DeviceActivity extends DeviceActivityPayload {
  id: string
  creationDate: string
  lastModifyDate: string
  lastActivityDate: string
  lastActivityUser: string
}

export class DeviceActivities extends TmrBaseResource {
  static endpoint = '/api/v1/deviceActivities'

  static async register(payload: DeviceActivityPayload): Promise<DeviceActivity> {
    return api.post(`${this.endpoint}`, payload).then(responseErrorCheck)
  }
}
